import { UpgradeAccountButton } from './UpgradeAccountButton.style';

export default UpgradeAccountButton;
